import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import withStyles from '@mui/styles/withStyles';
import PageTitle from '../ui/PageTitle';
import Notifications from './Notifications';
import { Grid } from '@mui/material';


const styleSheet = theme => ({
  
});
  
class Notification extends Component {


  render() {

    const classes = this.props.classes;
    const { isAuthenticated, needAssent } = this.props.auth;
    
    return (
      <div>
        {
          isAuthenticated() && !needAssent() && (
            <div className={classes.rootLoggedIn}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <PageTitle title="Notifications"  subtitle="History of changes to your account."/>
                <Notifications />
              </Grid>
            </Grid>
          </div>
          )
        }
        {
          (!isAuthenticated() || needAssent()) && (
            <Redirect to='/home' />
          )
        }
      </div>
    );
  }

}

export default withStyles(styleSheet)(Notification);

